module.exports = __webpack_public_path__ + "img/modal-arrow.dfe0bbf4.svg";